export default __webpack_public_path__ + "65d8040d6e9a21ab9d4886676bc2e00a.png";